var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "64.45314mm",
    viewBox: "0 0 132.29167 64.45314",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-232.54687)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g460",
    transform: "matrix(0.6575753,0,0,0.6575753,3.1101109e-7,101.70014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.104245,272.34558 C 27.179998,270.78213 24.534157,269.82 21.407255,269.82 9.5009732,269.82 9.0826126e-7,278.59938 9.0826126e-7,287.98009 9.0826126e-7,293.63257 4.5700889,297 10.463097,297 c 9.621238,0 21.407254,-9.01991 21.52752,-18.03982 v -79.97654 h -2.886372 z",
    id: "path431",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.47573,198.98364 v 12.02655 h 30.066368 v 5.893 H 31.47573 v 12.02655 h 30.066368 v 43.29557 c -1.924248,-1.56345 -4.570088,-2.52557 -7.69699,-2.52557 -11.906282,0 -21.407254,8.77938 -21.407254,18.16008 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.407254,-8.89964 21.527519,-18.03982 v -79.85627 z",
    id: "path433",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.84377,198.98364 H 63.89103 v 12.02655 h 32.95274 z",
    id: "path435",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.789658,198.98364 v 12.02655 h 30.066271 v 61.21512 c -1.924231,-1.56345 -4.570056,-2.52557 -7.696957,-2.52557 -11.906247,0 -21.40719,8.77938 -21.40719,18.16008 0,5.65248 4.570081,9.01991 10.463073,9.01991 9.621197,0 21.407175,-8.89964 21.527445,-18.03982 v -79.85627 z",
    id: "path437",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 129.39507,198.98364 H 96.442351 v 12.02655 h 32.952719 z",
    id: "path439",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.09507,198.98364 v 12.02655 h 30.06637 v 61.21512 c -1.92425,-1.56345 -4.57009,-2.52557 -7.69699,-2.52557 -11.90628,0 -21.40725,8.77938 -21.40725,18.16008 0,5.65248 4.57009,9.01991 10.46309,9.01991 9.62124,0 21.40726,-8.89964 21.52752,-18.03982 v -79.85627 z",
    id: "path441",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.922616,16.92532)",
    id: "g241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 151.92144,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 165.58992,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 179.2584,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxess);
export default __webpack_public_path__ + "static/media/cxess.692ace8180ffaf0ed10d7d84a8078c3f.svg";
export { ForwardRef as ReactComponent };